import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'store',
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addStore({}, store) {
      const { data } = await defaultApi.postStore(store)
      return data
    },
  },
}
